var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGym(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 294.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8ba0a5;\n      }\n\n      .cls-2 {\n        fill: #6c8387;\n      }\n\n      .cls-3 {\n        fill: #161616;\n      }\n\n      .cls-4 {\n        fill: #ffb288;\n      }\n\n      .cls-5 {\n        fill: #4d6f77;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #693523;\n      }\n\n      .cls-8 {\n        fill: #536468;\n      }\n\n      .cls-9 {\n        fill: #41bfb3;\n      }\n\n      .cls-10 {\n        fill: #59dbd1;\n      }\n\n      .cls-11 {\n        fill: #b64b1c;\n      }\n\n      .cls-12 {\n        fill: #fff252;\n      }\n\n      .cls-13 {\n        fill: #ebeced;\n      }\n\n      .cls-14 {\n        fill: #6a7e84;\n      }\n\n      .cls-15 {\n        fill: #dbdbdb;\n      }\n\n      .cls-16 {\n        fill: #c1bfbf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(0 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-1",
    width: 11.7,
    height: 251,
    transform: "translate(215.367 250.987) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-2",
    width: 5.9,
    height: 251,
    transform: "translate(206.564 250.987) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-2",
    d: "M210.5,11.8h122a1,1,0,0,0,1-1V8.9a1,1,0,0,0-1-1h-122a1,1,0,0,0-1,1v1.9A1.075,1.075,0,0,0,210.5,11.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-3",
    d: "M262.6,249.9l6.4-12.5c.3-.6,1.1-1,1.5-.8l6.7,3.7c.4.2.3.9-.2,1.3l-10.1,10.1C264.2,254.4,261.1,253,262.6,249.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-4",
    d: "M254.5,199.9c6.8,11.6,13.9,22.6,19.1,34.9,3.3,7.8-3.9,14.6-10,4.4-18.5-30.8-29.3-40.3-32.2-53.6a85.693,85.693,0,0,1-1.6-22.7l16.8,3.6C244,180.4,245.8,185.1,254.5,199.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-5",
    d: "M254.5,133.4c-3.7,15.7-6.4,25.8-7.8,33.2L229.9,163a179.105,179.105,0,0,1,4.6-30.6C237.9,117.6,256.7,124.1,254.5,133.4Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-3",
    d: "M301.4,242.8l6.5-12.5c.3-.6,1.1-1,1.5-.8l6.6,3.8c.4.2.3.9-.2,1.3l-10.3,10C302.9,247.4,299.7,246,301.4,242.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-5",
    d: "M259.5,126.8c1.7-15.4,20.3-10.3,19.2-.5-2.5,23.4-3.7,34.4-3.1,42.8l-15.3,2.8C257.4,157.1,258,141.2,259.5,126.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-4",
    d: "M301.3,233.5c-22.1-29.7-34-38.3-38.5-51.7a79.871,79.871,0,0,1-2.6-9.9l15.3-2.8c.6,8.6,3.8,13.9,11.9,25,8.2,11.2,16.6,21.8,23.2,33.9C315,235.7,308.7,243.4,301.3,233.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-4",
    d: "M248.1,85.9a5.84,5.84,0,0,0-.4,1.8c8.1,9.4-6.8,3.3-9.7.9-2.8-2.3-7.3-8.8-9.9-19l18.1-.5C248.4,74.6,250.3,80.3,248.1,85.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-4",
    d: "M239.9,49.8a58.89,58.89,0,0,0,2.9,11.7c.9,2.5,2.2,5.1,3.3,7.7l-18.1.4c-3.4-13.6-3.2-33.5,9.4-58.2,1.7-3.4,8.8-.7,7.3,2.8A62.833,62.833,0,0,0,239.9,49.8Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-4",
    d: "M245.1,8.7c-.8-2.7-3.2-4.3-5.3-3.6-2.1.6-3.1,3.3-2.3,6s3.2,4.3,5.3,3.6C244.9,14.1,245.9,11.4,245.1,8.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-1",
    width: 11.7,
    height: 251,
    transform: "translate(337.337 253.304) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-2",
    width: 5.9,
    height: 251,
    transform: "translate(328.434 253.304) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-6",
    d: "M294.3,75s-32-25.6-57.1-2.6C237.2,72.4,265.8,94.4,294.3,75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-6",
    d: "M284,107.8c2.5-6.8,6.5-13.5,8.3-20.6a25.686,25.686,0,0,0,.6-4,4.44,4.44,0,0,1-.8-1.1c-2.1-4.4-4.9-10.7-9.9-12.6-2-.8-24.5-4.9-29.7-4-9.2,1.5-16.9,5.3-18.4,13-.8,4.4-1.4,9-1.8,13.7a8.753,8.753,0,0,0,.2,1.6c1.3,8.9,2.5,15.9,1.9,23.9-.1,1.2-.2,2.3-.3,3.5-.4,4.2-1.1,10.4-1.7,14.6.1,1.5.9,5.1,1.9,6a5.613,5.613,0,0,0,3.8,1c13.3.3,26.7.5,40,.8.1-.2.1-.4.2-.6A91.29,91.29,0,0,1,284,107.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-4",
    d: "M261.5,74c1.5-1.9,3-3.7,4.6-5.6a2.734,2.734,0,0,0-.4-3.9,7.773,7.773,0,0,0-5.8-1.8c-2.3.3-6.2,2.1-5,4.6,1.5,3,.7,1.6,3.4,6.4A1.877,1.877,0,0,0,261.5,74Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-7",
    d: "M256.3,35.1l-1.1,4.2c-1.6,6.3.8,12.4,5.4,13.6s9.7-3,11.3-9.3l1.1-4.2v-.1c-4.1-4.2-9.5-6.4-15.2-8A15.849,15.849,0,0,0,256.3,35.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-4",
    d: "M267.9,47.4a2.515,2.515,0,1,1-2.6,1.9A2.284,2.284,0,0,1,267.9,47.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-7",
    d: "M268.4,45.3c1.1-4.2-.9-8.4-4.4-9.3a5.734,5.734,0,0,0-4.4.7l8.7,8.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-4",
    d: "M259.7,36.7a8.432,8.432,0,0,0-4,5.4l-1.6,6.2c-1.1,4.2.9,8.4,4.4,9.3s7.3-1.8,8.4-6l1.6-6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-4",
    d: "M261.3,67.5l-5.1-1.3a1.435,1.435,0,0,1-1-1.6l3.4-13.2a1.284,1.284,0,0,1,1.6-.9l5.1,1.3a1.435,1.435,0,0,1,1,1.6l-3.4,13.2A1.284,1.284,0,0,1,261.3,67.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-2",
    d: "M305.4,259.2h44.7a1.967,1.967,0,0,0,1.9-1.9v-3.8a1.967,1.967,0,0,0-1.9-1.9H305.4a1.967,1.967,0,0,0-1.9,1.9v3.8A1.9,1.9,0,0,0,305.4,259.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-1",
    d: "M319.3,259.2h35.1a1.967,1.967,0,0,0,1.9-1.9v-3.8a1.967,1.967,0,0,0-1.9-1.9H319.3a1.967,1.967,0,0,0-1.9,1.9v3.8A1.967,1.967,0,0,0,319.3,259.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-2",
    d: "M185,257.9h44.7a1.967,1.967,0,0,0,1.9-1.9v-3.8a1.967,1.967,0,0,0-1.9-1.9H185a1.967,1.967,0,0,0-1.9,1.9V256A1.9,1.9,0,0,0,185,257.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-1",
    d: "M199,257.9h35.1A1.967,1.967,0,0,0,236,256v-3.8a1.967,1.967,0,0,0-1.9-1.9H199a1.967,1.967,0,0,0-1.9,1.9V256A1.9,1.9,0,0,0,199,257.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-4",
    d: "M279.7,79.8a7.7,7.7,0,0,0,4.6,6.6c2.3,1.1,5,1.9,6.6.6,2.8-2.3,7.3-8.8,9.9-19l-18.1-.5C281,71.7,279.5,75.7,279.7,79.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-4",
    d: "M288.9,48.3A58.89,58.89,0,0,1,286,60c-.9,2.5-2.2,5.1-3.3,7.7l18.1.5c3.4-13.6,3.2-33.5-9.4-58.2-1.7-3.4-8.8-.7-7.3,2.8A62.384,62.384,0,0,1,288.9,48.3Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-4",
    d: "M283.7,7.3c.8-2.7,3.2-4.3,5.3-3.6,2.1.6,3.1,3.3,2.3,6s-3.2,4.3-5.3,3.6S282.9,9.9,283.7,7.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-8",
    d: "M332,25.3h1a.472.472,0,0,0,.5-.5V15.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.472.472,0,0,0,332,25.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-8",
    d: "M332,47.5h1a.472.472,0,0,0,.5-.5V37.6a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5V47A.536.536,0,0,0,332,47.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-8",
    d: "M332,69.6h1a.472.472,0,0,0,.5-.5V59.7a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.472.472,0,0,0,332,69.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-8",
    d: "M332,91.7h1a.472.472,0,0,0,.5-.5V81.8a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.472.472,0,0,0,332,91.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-8",
    d: "M332,113.9h1a.472.472,0,0,0,.5-.5V104a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,332,113.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-8",
    d: "M332,136h1a.472.472,0,0,0,.5-.5V126a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4C331.5,135.8,331.7,136,332,136Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-8",
    d: "M332,158.1h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.472.472,0,0,0,332,158.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-8",
    d: "M332,180.3h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,332,180.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-8",
    d: "M332,202.4h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.472.472,0,0,0,332,202.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-8",
    d: "M332,224.5h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5V224A.472.472,0,0,0,332,224.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-8",
    d: "M332,246.7h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,332,246.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-8",
    d: "M210,26h1a.472.472,0,0,0,.5-.5V16a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.562.562,0,0,0,210,26Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-8",
    d: "M210,48.1h1a.472.472,0,0,0,.5-.5V38.2a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,210,48.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-8",
    d: "M210,70.3h1a.472.472,0,0,0,.5-.5V60.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.642.642,0,0,0,210,70.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-8",
    d: "M210,92.4h1a.472.472,0,0,0,.5-.5V82.5a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,210,92.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-8",
    d: "M210,114.5h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5V114A.536.536,0,0,0,210,114.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-8",
    d: "M210,136.7h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.642.642,0,0,0,210,136.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-8",
    d: "M210,158.8h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,210,158.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-8",
    d: "M210,180.9h1a.472.472,0,0,0,.5-.5V171a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,210,180.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-8",
    d: "M210,203.1h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.642.642,0,0,0,210,203.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-8",
    d: "M210,225.2h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,210,225.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-8",
    d: "M210,247.3h1a.472.472,0,0,0,.5-.5v-9.4a.472.472,0,0,0-.5-.5h-1a.472.472,0,0,0-.5.5v9.4A.536.536,0,0,0,210,247.3Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-3",
    d: "M226.7,238.9l3.6-12.6c.2-.6.8-1.1,1.2-1l6.8,2.2c.4.1.4.7.1,1.3l-7.5,11.1C228.9,242.8,225.8,242,226.7,238.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-4",
    d: "M190.6,217.4c12.5,1.4,24.7,2.3,36.8,5.3,7.7,1.9,8.8,11.1-2.3,10-33.4-3.4-46.5-.6-58.1-5.9a81.348,81.348,0,0,1-17.9-11.5l12.1-10.6C170.1,214.4,174.6,215.6,190.6,217.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-9",
    d: "M140.7,180.2c9.7,11.5,15.7,19.2,20.5,24.4l-12.1,10.6a164.3,164.3,0,0,1-20.3-20.6C119.7,183.8,135,173.4,140.7,180.2Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-3",
    d: "M73.1,267.7,86,270.2c.6.1,1.2.7,1.1,1.1l-1.7,6.9c-.1.4-.7.5-1.3.2L72.5,272C69.4,270.2,69.9,267.1,73.1,267.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-10",
    d: "M148.6,183.3c13.2-6,18.7,11.8,10.3,15.6-20,9.1-30.3,13-36.8,17.4l-9.5-11C123.1,196,136.2,188.9,148.6,183.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-4",
    d: "M82.5,267.6c13.4-31.9,14.7-45.5,23.4-55.4,2.1-2.4,4.4-4.6,6.7-6.8l9.5,11c-6.6,4.5-9.3,9.6-14.4,21.4-5.1,11.9-9.7,23.7-16.3,34.8C87.3,279.6,78,278.1,82.5,267.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-11",
    d: "M172.1,108.1c0,1.8-.3,3.6.3,5.3.7,2.1,2.7,3.6,3.8,5.6,1.4,2.6.9,5.9-.4,8.5-.3.6-.7,1.2-1,1.7a5.161,5.161,0,0,1-.2,1.1h0a7.979,7.979,0,0,1-3.7,5.8,8.391,8.391,0,0,1-6.9,1,6.264,6.264,0,0,0-2.7-.6c-2.1,0-3.9,2.3-5.9,1.7-1.1-.4-1.8-1.6-3-2-1.3-.4-2.6.7-3.9,1.3-2.8,1.3-4.5-.8-5.1-2.4a13.68,13.68,0,0,0-2.5-3.5,10.518,10.518,0,0,0-2.7-2c-1.6-.7-3.5-.6-5.3-.7-1.8-.2-3.7-.8-4.6-2.4-1.5-2.8,1.7-6.1,1.2-9.3-.3-1.7-1.5-3-2.5-4.4-3.9-5.9-1.4-15,4.9-18.1,5.3-2.7,12.3-.7,16,3.9a12.316,12.316,0,0,1,8.5,2.4c1.4,1.1,2.6,2.4,4.2,2.8,3.1.7,6.6-2.2,9.4-.5C171.6,104.3,172.1,106.3,172.1,108.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-4",
    d: "M101.9,116.7a2.934,2.934,0,0,1,.4-1.6,2.79,2.79,0,0,1,2.7-1.8c.1,0,.2.1.3.1v-.1c.2,0,.5.1.7.1-.9,0-.3.1.1.1a10.375,10.375,0,0,0,1,.4c.1.1.2.1.4.2a.349.349,0,0,0,.2.1c.4.3.7.6,1.1.9l.1.1c.3,1.4.6,2.7.8,4.1a9.163,9.163,0,0,1-.1,3.3,3.3,3.3,0,0,1-2.1,2.2c.3,7.5.2,16.1,1.1,23.4,4.9-2.9,10.4-8,14.7-12.2,5.7-5.6,13.7.5,12.8,6.7l-30,18.1a3.227,3.227,0,0,1-4.9-2.6A125.228,125.228,0,0,1,101.9,116.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-4",
    d: "M140.1,108.5a2.084,2.084,0,0,1,1.9,2.1c0,1.2-.7,2.2-1.7,2.2a2.084,2.084,0,0,1-1.9-2.1A2.015,2.015,0,0,1,140.1,108.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-4",
    d: "M130.3,101.5a7.559,7.559,0,0,0-2,5.6l.2,5.7c.2,3.9,2.9,6.9,6.1,6.8s5.7-3.4,5.6-7.3l-.2-5.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-4",
    d: "M140,126.9l-4.7.2a1.216,1.216,0,0,1-1.2-1.2l-.5-12.7a1.23,1.23,0,0,1,1.1-1.3l4.7-.2a1.216,1.216,0,0,1,1.2,1.2l.5,12.7A1.23,1.23,0,0,1,140,126.9Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-12",
    d: "M162.8,189a2.354,2.354,0,0,1-.2.8H126.1c-.3-5.8.7-11.1,1.3-17.8a65.346,65.346,0,0,0-3-24.8,29.212,29.212,0,0,1-.6-7.2h0c0-.3.1-.5.1-.8a3.545,3.545,0,0,1,.3-1.1h.1a26.93,26.93,0,0,1,2.9-5.9c8.3-9.7,16.6-7.8,22.1-4.4h0c12.4,2.3,6.3,17.9,6.3,17.9h0c-1,4.9-2.9,9.6-3,14.7a19.891,19.891,0,0,0,.5,4.9,22.5,22.5,0,0,0,.8,2.4c2.3,5.4,6.7,9.9,8.4,15.6a20.892,20.892,0,0,1,.5,5.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-4",
    d: "M143.2,130.1a11.39,11.39,0,0,1-3.7,4.2,15.209,15.209,0,0,1-5.2,2.7,6.31,6.31,0,0,1-3.6-.1,3.542,3.542,0,0,1-2.3-4.6,8.383,8.383,0,0,1,3.1-4.5,15.412,15.412,0,0,1,5-2.4c1.5-.4,4.4-1.2,5.8-.2C143.9,126.2,143.9,128.6,143.2,130.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-4",
    d: "M156.9,172.1a3.924,3.924,0,0,1-1.4.8,2.765,2.765,0,0,1-3.2-.8.367.367,0,0,1-.1-.3l-.1.1c-.1-.2-.3-.4-.4-.6.6.7.3.2,0-.2a4.18,4.18,0,0,0-.4-1c0-.1-.1-.3-.1-.4v-.2c0-.5-.1-.9-.1-1.4V168c.8-1.2,1.6-2.3,2.5-3.4a7.509,7.509,0,0,1,2.5-2.2,3.182,3.182,0,0,1,3,.1c5.3-5.3,11.8-11.1,16.5-16.6-5.4-1.6-12.9-2.3-18.9-2.6-7.9-.4-8.9-10.5-3.7-13.9l33.6,9.9a3.191,3.191,0,0,1,1.3,5.4A122.15,122.15,0,0,1,156.9,172.1Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-2",
    d: "M4.2,288.6H172.5a4.225,4.225,0,0,0,4.2-4.2v-8.9a4.225,4.225,0,0,0-4.2-4.2H4.2A4.225,4.225,0,0,0,0,275.5v8.9A4.225,4.225,0,0,0,4.2,288.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-1",
    d: "M58.9,288.6H227.2a4.225,4.225,0,0,0,4.2-4.2v-8.9a4.225,4.225,0,0,0-4.2-4.2H58.9a4.225,4.225,0,0,0-4.2,4.2v8.9A4.225,4.225,0,0,0,58.9,288.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-1",
    width: 17.7,
    height: 94.5,
    transform: "translate(44.701 271.321) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-2",
    width: 17.7,
    height: 94.5,
    transform: "translate(40.103 271.321) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-2",
    d: "M15,178H57.8c1.7,0,2.5-1.4,1.8-3.1l-7.8-19.2a5.152,5.152,0,0,0-4.4-3.1H4.7c-1.7,0-2.5,1.4-1.8,3.1l7.8,19.2A5.01,5.01,0,0,0,15,178Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-1",
    d: "M57.8,178h0c1.7,0,2.5-1.4,1.8-3.1l-7.8-19.2a5.152,5.152,0,0,0-4.4-3.1h0c-1.7,0-2.5,1.4-1.8,3.1l7.8,19.2A5.279,5.279,0,0,0,57.8,178Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-2",
    d: "M353.2,239.1h-4.7c.6,0,1,.7,1,1.6v52.5c0,.9-.5,1.6-1,1.6h4.7c.6,0,1.1-.7,1.1-1.6V240.7C354.3,239.8,353.8,239.1,353.2,239.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-1",
    d: "M349.6,293.2V240.7c0-.9-.5-1.6-1-1.6h-3c-.6,0-1,.7-1,1.6v52.5c0,.9.5,1.6,1,1.6h3C349.1,294.8,349.6,294.1,349.6,293.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-2",
    d: "M394,239.1h-4.7c.6,0,1,.7,1,1.6v52.5c0,.9-.5,1.6-1,1.6H394c.6,0,1.1-.7,1.1-1.6V240.7C395.1,239.8,394.6,239.1,394,239.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-1",
    d: "M390.4,293.2V240.7c0-.9-.5-1.6-1-1.6h-3.1c-.6,0-1,.7-1,1.6v52.5c0,.9.5,1.6,1,1.6h3C389.9,294.8,390.4,294.1,390.4,293.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-2",
    d: "M456.9,239.1h-4.7c.6,0,1,.7,1,1.6v52.5c0,.9-.5,1.6-1,1.6h4.7c.6,0,1.1-.7,1.1-1.6V240.7C457.9,239.8,457.5,239.1,456.9,239.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-1",
    d: "M453.3,293.2V240.7c0-.9-.5-1.6-1-1.6h-3c-.6,0-1,.7-1,1.6v52.5c0,.9.5,1.6,1,1.6h3C452.8,294.8,453.3,294.1,453.3,293.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-2",
    d: "M504.6,239.1h-4.7c.6,0,1,.7,1,1.6v52.5c0,.9-.5,1.6-1,1.6h4.7c.6,0,1.1-.7,1.1-1.6V240.7C505.6,239.8,505.1,239.1,504.6,239.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M500.9,293.2V240.7c0-.9-.5-1.6-1-1.6h-3c-.6,0-1,.7-1,1.6v52.5c0,.9.5,1.6,1,1.6h3C500.5,294.8,500.9,294.1,500.9,293.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-1",
    width: 95.9,
    height: 4.1,
    transform: "translate(352.3 248)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-3",
    d: "M494.6,217.4l-11.4,7.9a1.333,1.333,0,0,0-.6,1.5l4.5,6c.3.3.9.2,1.3-.4l8.5-11.2C499.3,218.3,497.5,215.5,494.6,217.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-4",
    d: "M444.8,216.1c12.2,5.1,23.9,10.6,36.6,14,8,2.2,13.7-5.7,3-10.3-32.5-14-43.1-23.2-56.5-24.2a88.4,88.4,0,0,0-22.3,1.4l5.7,15.9C424.4,208.4,429.2,209.6,444.8,216.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-13",
    d: "M379.9,224.9c14.8-5.6,24.3-9.6,31.3-12L405.5,197a170.106,170.106,0,0,0-29.2,8.5C362.4,210.8,371.2,228.2,379.9,224.9Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-4",
    d: "M359.9,143.3c-4.6,2.8-8.4,5-12.1,7.5-8,5.3-1.1,18.6,7,13.3,4.2-2.8,8.5-5.3,12.7-7.9h0c.6-.4,1.2-.7,1.8-1.1,4.1-2.5,9.6-5,12.7-8.8l.3-.6L366.7,139C364.2,140.7,362,142.1,359.9,143.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-4",
    d: "M348.8,123.2a12.188,12.188,0,0,0-2.7,0,6.154,6.154,0,0,0-3.2,1.1,2.929,2.929,0,0,0-1.1,3,5.174,5.174,0,0,0,1.3,2.2l.2.2c1.4,1,4,.8,5.3.7a9.006,9.006,0,0,0,1.6-.3,19.049,19.049,0,0,0,3.8,2.2,128.355,128.355,0,0,1,11.8,6.6c2.1,1.2,4.2,2.5,6.4,3.6,1.1,1.8,4.6,3.7,4.6,3.7l3.5,1.9a14.706,14.706,0,0,0,8-9.3,3.311,3.311,0,0,0-.9-3.5c-3-2.8-10-5.4-17-7.5a173,173,0,0,0-16.9-4.3A8.775,8.775,0,0,0,348.8,123.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-5",
    d: "M311.5,176.5s14.7-37.5,47.4-30.1C358.9,146.4,345.3,179.1,311.5,176.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-5",
    d: "M316.8,181.5c-.3-4.8-1.1-11.5,2.2-15.6,1.4-1.7,18.5-16.2,23.3-18,5.8-2.2,11.6-3.1,16.3-1.7a8.233,8.233,0,0,0,1.6,2.2c5.8,6.2,7.8,9.1,8.6,17.5a37.5,37.5,0,0,0,4.9,15.7c4.7,8,12.1,12.9,20.3,16.6.6,1.4,1.6,4.6,1.2,5.8-.4,1.3-1.6,2-2.7,2.7-11.2,6.8-22.5,13.5-33.7,20.3q-21.75-20.7-42.8-42.5A4.551,4.551,0,0,0,316.8,181.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-4",
    d: "M315.9,184.3c-3.5-4.4-7.2-8.6-10.8-12.8l-1.5-1.8c-2.8-3.4-4.1-4.5-6.5-8.5,1-1.1,1.6-4.2,2.1-5.6l12.8-2.1c2.1,2.6,4,4.9,5.8,6.9,4,4.6,7.2,8.2,10.3,12.2C334.6,181,322.6,192.8,315.9,184.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-4",
    d: "M325.8,130.2a11.507,11.507,0,0,1,2.5-1.2,6.587,6.587,0,0,1,3.4-.5,2.892,2.892,0,0,1,2.3,2.2,4.952,4.952,0,0,1-.2,2.5c0,.1-.1.1-.1.2-.8,1.6-3.2,2.5-4.5,2.9a7.494,7.494,0,0,1-1.6.5,22.489,22.489,0,0,1-2.4,3.6,120.187,120.187,0,0,0-7.7,11.1c-1.3,2-2.7,4.1-4.2,6-.2,2.1-2.5,5.3-2.5,5.3l-2.4,3.2s-6,.6-11.3-4.9a3.235,3.235,0,0,1-.7-3.5c1.5-3.8,6.6-9.2,12-14.1,5.5-5,11.2-9.6,13.4-11.3A10.6,10.6,0,0,1,325.8,130.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-14",
    width: 13.1,
    height: 16.5,
    transform: "translate(449.7 211.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-2",
    width: 13.1,
    height: 16.5,
    transform: "translate(453.1 211.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-2",
    d: "M509.5,242H355.8a3.543,3.543,0,0,1-3.5-3.5v-7.9a3.543,3.543,0,0,1,3.5-3.5H509.5a3.543,3.543,0,0,1,3.5,3.5v7.9A3.478,3.478,0,0,1,509.5,242Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-4",
    d: "M339,159.6c-2.2-.9-4.4-1.7-6.6-2.5a2.615,2.615,0,0,1-1.5-3.5,8.046,8.046,0,0,1,4.1-4.4c2.1-.9,6.3-1.2,6.5,1.5a61.794,61.794,0,0,1,.2,7.1A1.956,1.956,0,0,1,339,159.6Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-7",
    d: "M348.2,125.2l-.4,4.3c-.6,6.4-4.8,11.2-9.5,10.8-4.6-.4-8-5.9-7.4-12.3l.4-4.3v-.1c5.1-2.6,10.9-2.8,16.7-2.4A17.309,17.309,0,0,1,348.2,125.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-4",
    d: "M333.4,132.8a2.213,2.213,0,0,0-2.2,2.2,2.3,2.3,0,0,0,1.8,2.6,2.213,2.213,0,0,0,2.2-2.2A2.243,2.243,0,0,0,333.4,132.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-7",
    d: "M333.5,130.7c.4-4.3,3.6-7.5,7.1-7.2a5.441,5.441,0,0,1,3.8,2.1l-11,5.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-4",
    d: "M344.5,125.5a7.988,7.988,0,0,1,1.9,6.3l-.6,6.3c-.4,4.3-3.6,7.5-7.1,7.2-3.6-.3-6.2-4.1-5.8-8.3l.5-6.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-4",
    d: "M332.9,153.5l5.2.5a1.322,1.322,0,0,0,1.4-1.2l1.2-13.4a1.322,1.322,0,0,0-1.2-1.4l-5.2-.5a1.322,1.322,0,0,0-1.4,1.2l-1.2,13.4A1.208,1.208,0,0,0,332.9,153.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-1",
    d: "M460.9,242H341.4a3.543,3.543,0,0,1-3.5-3.5v-7.9a3.543,3.543,0,0,1,3.5-3.5H460.8a3.543,3.543,0,0,1,3.5,3.5v7.9A3.394,3.394,0,0,1,460.9,242Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-3",
    d: "M482.4,236.3l-11.3,7.9c-.6.4-.8,1.2-.5,1.5l4.6,6c.3.3.9.2,1.3-.4l8.4-11.3C487.1,237.1,485.3,234.3,482.4,236.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-6",
    d: "M363.9,210.2c-14.9,3.6-7.9,21.9,1.5,19.6,22.5-5.4,33.5-8.8,41.8-9.3l.8-15.3C393.3,204.3,377.8,206.9,363.9,210.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-4",
    d: "M473.4,237.4c-31.8-17.8-41.7-28.3-55.3-30.9-3.3-.6-6.6-1-10-1.3l-.8,15.3c8.5-.5,14,2,25.9,8.5,12,6.5,23.4,13.4,36,18.3C477.2,250.5,483.9,243.3,473.4,237.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-2",
    d: "M483.6,212.7H427.4a2.263,2.263,0,0,1-2.3-2.3v-5.2a2.263,2.263,0,0,1,2.3-2.3h56.2a2.263,2.263,0,0,1,2.3,2.3v5.2A2.326,2.326,0,0,1,483.6,212.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-1",
    d: "M433.8,207.9a4.9,4.9,0,1,1-4.9-4.9A4.908,4.908,0,0,1,433.8,207.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-8",
    d: "M347.1,254.4h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A1.075,1.075,0,0,1,347.1,254.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-8",
    d: "M347.1,275.5h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A1.075,1.075,0,0,1,347.1,275.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-8",
    d: "M348.1,294.8v-7.3a1.075,1.075,0,0,0-1-1,.945.945,0,0,0-1,1v7.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-8",
    d: "M387.8,254.4h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A1,1,0,0,1,387.8,254.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-8",
    d: "M387.8,275.5h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A1,1,0,0,1,387.8,275.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-8",
    d: "M388.8,294.8v-7.3a1.075,1.075,0,0,0-1-1,.945.945,0,0,0-1,1v7.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-8",
    d: "M450.7,255.8h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A1,1,0,0,1,450.7,255.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-8",
    d: "M450.7,276.9h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A.945.945,0,0,1,450.7,276.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-8",
    d: "M451.7,294.8V289a1.075,1.075,0,0,0-1-1,.945.945,0,0,0-1,1v5.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-8",
    d: "M498,255.8h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A1,1,0,0,1,498,255.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-8",
    d: "M498,276.9h0a.945.945,0,0,1-1-1v-8a1.075,1.075,0,0,1,1-1h0a.945.945,0,0,1,1,1v8A.945.945,0,0,1,498,276.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-8",
    d: "M499,294.8V289a1.075,1.075,0,0,0-1-1,.945.945,0,0,0-1,1v5.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-2",
    width: 48,
    height: 4.1,
    transform: "translate(455.5 248)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-15",
    cx: 28.9,
    cy: 28.9,
    r: 28.9,
    transform: "translate(395 28.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-6",
    cx: 23.2,
    cy: 23.2,
    r: 23.2,
    transform: "translate(400.7 34.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-16",
    d: "M424.5,59.3h0a1,1,0,0,0,1-1V40.6a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V58.4A.987.987,0,0,0,424.5,59.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-16",
    d: "M416.8,56.3l7.4,3c.4.1.8,0,.9-.4h0c.1-.4,0-.8-.4-.9l-7.4-3c-.4-.1-.8,0-.9.4h0A.74.74,0,0,0,416.8,56.3Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.94fa9070ed3ec2e4f73179c2762fd361.svg";
export { ForwardRef as ReactComponent };